import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, FormField, Link, Modal, Popover, Select, SpaceBetween, StatusIndicator, Table, TextFilter } from '@cloudscape-design/components';

import Header from "@cloudscape-design/components/header";
import { mdiAlert, mdiCheckUnderlineCircle, mdiFileExcel, mdiMagnify, mdiTimerSand } from '@mdi/js';
import Icon from '@mdi/react';
import { differenceInDays, format, parse } from 'date-fns';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemFlight, OptionDefinition } from '../../../../../resources/types';
import { buildBreadcrumbItems, exportToExcel, getCookie, getUrlVersion, minutesToHHMM2, setLoading, setParameters } from '../../../../commons/functions';

export const ReportsEDVProgressPage = () => {
  const { menu, parameters } = useGlobalState();
  const [students, setStudents] = useState<any[]>([])
  const [studentsExcel, setStudentsExcel] = useState<any[]>([])
  const [student, setStudent] = useState<any>(null)
  const [years, setYears] = useState<OptionDefinition[]>([]);
  const [DGAC, setDGAC] = useState<any[]>([]);
  const [filteringText, setFilteringText] = useState("");
  const [status, setStatus] = useState<string>("PENDING");
  const [flights, setFlights] = useState<ItemFlight[]>([]);



  const handleGetPeriods = async () => {
    try {
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/edv/students/years',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({})
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.years) {
        setYears(data.years)
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleGetStudents = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/edv/students/report',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({
          ...status === "COMPLETE" && { year: parameters.year },
          licenceType: parameters.course,
          complete: status === "COMPLETE" ? 1 : 0
        })
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.students) {
        setStudents(data.students)
        const exc = data.students.map((item: any) => ({
          id: item.idUserStudent,
          idUser: item.idUser,
          Usuario: item.displayName,
          idInstructor: item.idInstructor,
          Instructor: item.instructor,
          Curso: item.licenceType === "GLIDER" ? "Planeador" : item.licenceType === "PLANE" ? "Avión" : item.licenceType,
          Inicio: item.dateStart !== "" ? item.dateStart : "No iniciado",
          Solo: item.dateSolo !== "" ? item.dateSolo : "N/D",
          Termino: item.dateLicence !== "" ? item.dateLicence : "Pendiente",
          T_Vuelo: minutesToHHMM2(item?.TotalTime) || 0,
          Vuelos: item.TotalFlights
        }))
        setStudentsExcel(exc);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  const filtered: any[] = students.filter((item) => {
    const normalize = (str: string | undefined | null) =>
      (str || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
    const searchWords = normalize(filteringText).split(/\s+/).filter(Boolean);
    const text = normalize([item?.instructor, item?.displayName].join(" "));
    return searchWords.every((word) => text.includes(normalize(word)));
  });
  const handleGetFlights = async (user: any) => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/flights/list',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({
          columns: "idFlight, registration, departureDate, arrivalDate, flightType, delta, userInstructor",
          dateStart: user?.dateStart,
          ...(user?.dateLicence && { dateEnd: user.dateLicence }),
          idUser: user.idUser,
          groupTypeMasterCode: user.licenceType,
          idFlightTypes: [1135, 2799],
          order: "asc",
          orderBy: "departureDate",
        })
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.flights) {
        const indexedFlights = data.flights.map((item: any, index: number) => ({
          ...item,
          // Add a new property to the item object
          index: index + 1
        }));
        setFlights(indexedFlights)
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    //if (years && years.length > 0)
    //handleGetStudents();
  }, [parameters.year, parameters.course]);

  useEffect(() => {
    handleGetPeriods();
  }, []);


  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1"
            description="Reporte de avance de alumnos de EDV"
            actions={
              <>
                <Favorites /></>}>Avance alumnos</Header>
          <Table
            onRowClick={(item) => {
              setStudent(item.detail.item);
            }}
            variant='embedded'
            stickyHeader
            filter={
              <SpaceBetween direction="horizontal" size="xs">

                <FormField label="Estado">
                  <Select
                    options={[{ label: "Pendiente", value: "PENDING" }, { label: "Finalizado", value: "COMPLETE" }]}
                    selectedOption={[{ label: "Pendiente", value: "PENDING" }, { label: "Finalizado", value: "COMPLETE" }].find(c => c.value === status) || { label: "Pendiente", value: "PENDING" }}
                    onChange={({ detail }) => {
                      setStatus(detail.selectedOption.value);
                    }}
                  />
                </FormField>
                {status === "COMPLETE" && (
                  <FormField label="Filtro anual">
                    <Select
                      options={years}
                      selectedOption={years.find(y => y.value.toString() === parameters.year.toString()) || null}
                      onChange={({ detail }) => {
                        if (detail && detail.selectedOption.value !== "") {
                          setParameters({
                            ...parameters,
                            year: Number(detail.selectedOption.value)
                          });
                        }
                      }}
                    />
                  </FormField>
                )}
                <FormField label="Tipo de curso">
                  <Select
                    options={[{ label: "Planeador", value: "GLIDER" }, { label: "Avión", value: "PLANE" }]}
                    selectedOption={[{ label: "Planeador", value: "GLIDER" }, { label: "Avión", value: "PLANE" }].find(c => c.value === parameters.course) || { label: "Planeador", value: "GLIDER" }}
                    onChange={({ detail }) => {
                      setParameters({
                        ...parameters,
                        course: detail.selectedOption.value
                      });
                    }}
                  />
                </FormField>
                <FormField label="&nbsp;">
                  <Button style={{ root: btnIconForm }}
                    disabled={parameters.year === "" || parameters.course === ""}
                    onClick={() => handleGetStudents()}><Icon path={mdiMagnify} size={1} /></Button>
                </FormField>
                <FormField label="&nbsp;">
                  <TextFilter filteringText={filteringText} onChange={({ detail }) => setFilteringText(detail.filteringText)}
                    filteringPlaceholder='Filtrar resultados'
                    disabled={students.length === 0}
                  />
                </FormField>
                <FormField label="&nbsp;">

                  <Button disabled={studentsExcel.length === 0} onClick={() => exportToExcel(studentsExcel, `Reporte_Avance_${format(new Date(), "dd-MM-yyyy.HHmm")}.xlsx`)} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>
                </FormField>
              </SpaceBetween>
            }
            columnDefinitions={[
              { id: 'instructor', header: 'Alumno/Instructor', cell: item => <FormField label={item.instructor}>{item?.displayName}</FormField> },
              { id: 'course', header: 'Curso', cell: item => item?.licenceType === "GLIDER" ? "Planeador" : item?.licenceType === "PLANE" ? "Avión" : item?.licenceType },
              {
                id: 'start', header: 'Inicio/Termino', cell: item => <FormField label={item.dateStart !== "" ? item.dateStart :
                  <><Icon path={mdiTimerSand} size={1} />No iniciado</>}>{item.dateStart !== "" ? item?.dateLicence === "" ? <StatusIndicator type="pending">Pendiente</StatusIndicator> : <StatusIndicator type="success">{item.dateLicence}</StatusIndicator> : ""}</FormField>
              },
              {
                id: 'solo', header: 'Solo', width: 50, cell: item => item?.dateSolo !== "" ?
                  <Popover dismissButton={false} triggerType="custom"
                    content={<>{item.dateSolo}, {differenceInDays(parse(item.dateSolo, "dd-MM-yyyy", new Date()), parse(item.dateStart, "dd-MM-yyyy", new Date()))} días</>}
                    dismissAriaLabel="Close popover" header="Fecha de primer vuelo solo">
                    <Icon path={mdiCheckUnderlineCircle} size={1} color={"green"} />
                  </Popover> : ""
              },
              { id: 'end', header: 'Totales', cell: item => <Link onClick={() => handleGetFlights(item)}>{item?.TotalFlights || 0}Vº {minutesToHHMM2(item?.TotalTime) || 0}</Link> },
              {
                id: 'erxt', header: 'Avance', cell: item => <>{Math.round(item.TotalFlights / 50 * 100)}% {Math.round(item.TotalFlights / 50 * 100) > 100 ? <Icon path={mdiAlert} size={1} color={"red"} /> :
                  Math.round(item.TotalFlights / 50 * 100) > 85 ? <Icon path={mdiAlert} size={1} color={"orange"} /> :
                    ""}</>

              },
            ]}
            items={filtered}
            loadingText="Cargando alumnos..."
          />
          <Modal size='large' visible={flights.length > 0} onDismiss={() => setFlights([])} closeAriaLabel="Close modal" header={`Vuelos de ${student?.displayName}`}>
            <Table
              variant="borderless"
              stickyHeader
              cellVerticalAlign='top'
              columnDefinitions={[
                { id: 'index', header: '', cell: item => item?.index, width: 30 },
                { id: 'registration', header: 'Matrícula', cell: item => <FormField label={item?.registration}>{item?.userInstructor}</FormField> },
                { id: 'departureDate', header: 'Fecha', cell: item => item?.departureDate },
                { id: 'flightType', header: 'Tipo Vuelo', cell: item => item?.flightType },
                { id: 'departureArrivalDelta', header: 'Duración', cell: item => minutesToHHMM2(item?.delta ?? 0) },
              ]}
              items={flights}
              loadingText="Cargando vuelos..."
            />
          </Modal>

        </SpaceBetween >
      }
    />
  )
};
